import { jsx as _jsx } from "react/jsx-runtime";
import { GeomeLogo } from "../icons/geomeLogo";
export const GeomeLogoLink = ({ className }) => (_jsx("a", { className: className, href: "https://www.geo.me", title: "Google Enterprise Partner - Geo.me", target: "_blank", rel: "noreferrer", children: _jsx(GeomeLogo, {}) }));
